import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state() {
    return {
      page_option: {
        name: "",
        page: 0,
        page_total: 1,
        search: "",
        limit: 10,
        total_count: 0,
      },
      token: "",
      user_info: {
        is_admin: 0,
      },
      lan: "kor",
      lan_list: ["kor", "eng"],
    }
  },
  mutations: {
    set_token: function (state, token) {
      state.token = token;
    },
    set_user_info: function (state, user_info) {
      state.user_info = user_info;
    },
    set_page: function (state, page_option) {
      state.page_option = page_option;
    },
    get_page: function (state) {
      return state.page_option;
    },
    change_lan(state) {
      state.lan = (state.lan === 'kor' || state.lan === 'KR') ? 'eng' : 'kor';
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState()
  ]
})
